import { Record } from "immutable";
import moment from "moment";
import { MEDIA_TYPE_IMAGE, IMedia } from "constants/media";

const defaults = {
    created_at_ms: undefined,
    id: undefined,
    images: {},
    media_type: MEDIA_TYPE_IMAGE,
    videos: {},
};

export class Media extends Record(defaults) {
    declare id: string;
    declare images: any;
    declare videos: any;
    declare media_type: IMedia;
    declare created_at_ms: moment.Moment;

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(args.created_at_ms),
        });
    }
}
